var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',{key:_vm.width,staticClass:"split-text"},[_c(_vm.tag,{ref:"slot",tag:"component",class:_vm.innerClasses,domProps:{"innerHTML":_vm._s(_vm.text)}},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }